import React, { useEffect, useCallback, useState} from 'react';
import AccumulatorMapper from './AccumulatorMapper.js';
import {connect} from 'react-redux';

const ParametersMapper = ({effect, children, len, _parameters, isDraggable}) => { 
    let [parameters, setParameters] = useState(effect._parameters);
    useEffect(() => {
        setParameters(_parameters);
    }, [len, setParameters, effect]);
    return (
        <div className="acc-column mappings parameters-list">
          {parameters.map(
              (parameter, i) =>
                  <AccumulatorMapper
                    isDraggable={isDraggable}
                    key={i}
                    onMapped={() => setParameters([... effect._parameters])}
                    i={i}
                    effect={effect}/>)}
          <AccumulatorMapper
            isDraggable={isDraggable}
            key={parameters.length}
            onMapped={() => setParameters([...effect._parameters])}
            effect={effect}
            i={parameters.length}/>
          {children}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      len: props.effect._parameters.length,
      _parameters: props.effect._parameters
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParametersMapper);
